import { render, staticRenderFns } from "./ServiceNeedSetMoney.vue?vue&type=template&id=0d991208"
import script from "./ServiceNeedSetMoney.vue?vue&type=script&lang=js"
export * from "./ServiceNeedSetMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports